import React from 'react';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { StyledActionButtons } from '../index.style';

const ActionButton = ({
  onGoBack,
  onNext,
  labelGoBack,
  labelNext,
  disabledNext,
}) => (
  <StyledActionButtons>
    <CommonButton
      variant="outlined"
      textProps={{
        variantText: 'body-16-bold',
        color: COLOR.darkBlue,
      }}
      customStyle={{
        width: '30%',
      }}
      onClick={onGoBack}
    >
      {labelGoBack}
    </CommonButton>
    <CommonButton
      variant="contained"
      textProps={{
        variantText: 'body-16-bold',
        color: COLOR.darkBlue,
      }}
      customStyle={{
        width: '70%',
      }}
      onClick={onNext}
      disabled={disabledNext}
    >
      {labelNext}
    </CommonButton>
  </StyledActionButtons>
);

export default ActionButton;
